import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Ofwca} from '../../../shared/interface/ofwca';
import {Observable, ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {OfwcaService} from '../../../shared/services/ofwca.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MatSlideToggleChange} from "@angular/material/slide-toggle";
import {HttpErrorResponse} from "@angular/common/http";
import {Partner} from "../../../shared/interface/partner";

@Component({
  selector: 'app-ofwcas-list',
  templateUrl: './ofwcas-list.component.html',
  styleUrls: ['./ofwcas-list.component.scss']
})
export class OfwcasListComponent implements OnDestroy, OnInit, AfterViewInit {
  @Input() ofwcas: Observable<Ofwca[]>;
  @Input() partnerObject?: Partner = null;
  @Input() excludeColumns: string[] = [];
  @Input() disableLinks = false;
  @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ofwcasDataSource: MatTableDataSource<Ofwca> = new MatTableDataSource<Ofwca>([]);
  displayedColumns: string[] = [
    'fullName', 'status', 'pesel', 'email', 'phone', 'ASF360', 'facility', 'partner', 'assetsRegional', 'competitionRequirementsMet', 'actions'
  ];
  userPermissions: ReplaySubject<UserPermissions>;
  updateInProgress = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private ofwcaService: OfwcaService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.ofwcas
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((ofwcas: Ofwca[]) => this.ofwcasDataSource.data = ofwcas);

    // if (this.partnerObject) {
    //   this.excludeColumns.push('facility');
    // } else {
    //   this.excludeColumns.push('active');
    // }

    this.displayedColumns = this.displayedColumns.filter((e: string) => {
      return this.excludeColumns.indexOf(e) === -1;
    });
  }

  ngAfterViewInit(): void {
    this.ofwcasDataSource.paginator = this.paginator;
  }

  deleteOfwca(ofwca: Ofwca): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć OFWCA?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ofwcaService.deleteOfwca(ofwca.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto OFWCA', '', {duration: 2000});
            this.changed.emit(true);
          });
      }
    });
  }

  formChanged(
    $event: MatSlideToggleChange,
    ofwca: Ofwca,
    formData: {active: boolean; partner: string}
  ): void {
    this.updateInProgress = true;

    this.ofwcaService.updateActive(ofwca.uuid, formData)
      .subscribe(() => {
        this.snack.open('Pomyślnie zakutalizowano OFWCA', '', {duration: 2000});
        this.updateInProgress = false;
        if (formData.active) {
          ofwca.activeUnderPartnersIds.push(this.partnerObject.uuid);
        } else {
          ofwca.activeUnderPartnersIds = ofwca.activeUnderPartnersIds.filter((partnerId: string) =>
            this.partnerObject.uuid !== partnerId);
        }
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy aktualizacji wystąpił błąd', error.status.toString(), {duration: 2000});
        this.updateInProgress = false;
      });
  }
}
